import React from 'react'
import { Offcanvas, Tab, Tabs } from 'react-bootstrap'
import FullSyncTab from './FullSyncTab'
import RestrictionsTab from './RestrictionsTab';

interface RestrictionSettingsDialogProps {
    show: boolean;
    onClose: () => void;
}

const RestrictionSettingsDialog: React.FC<RestrictionSettingsDialogProps> = ({ show, onClose }) => {
    const handleClose = () => {
        onClose();
    }

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" className="offcanvas-responsive">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Restriction Settings</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Tabs
                    defaultActiveKey='restrictions'
                    className="mb-3 text-blue"
                    variant="underline"
                >
                    <Tab eventKey='restrictions' title='Restrictions'>
                        <RestrictionsTab onClose={handleClose} />
                    </Tab>
                    <Tab eventKey='settings' title='Settings'>
                        <FullSyncTab onClose={handleClose} />
                    </Tab>
                </Tabs>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default RestrictionSettingsDialog